export const isAbortError = (e: any) => {
  return e && typeof e === 'object' && 'name' in e && e.name === 'AbortError';
};
